module.exports = __webpack_public_path__ + "static/media/slika5.c2d41569.png";